import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse } from '@boma/client-shared';
import {
  IStockBelowMinimumItem,
  IStockMinimumStockRule,
} from '@boma/supplier-portal/shared/entities';
import { HelperFunctionsService } from '../helper-functions/helper-functions.service';

@Injectable({
  providedIn: 'root',
})
export class MinimumStockService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient,
    private helperService: HelperFunctionsService
  ) {
    this.base = configuration.apiRoute;
    this.version = '2.0'; //not sure what the best practice would be for this I guess until the majority of calls are v2 we can leave it like this
  }

  getMinimumStockRules(
    entityId: string, //required
    page: number = 1,
    pageSize: number = 500,
    productIds: string[] = [],
    locationIds: string[] = []
  ) {
    const url = `${this.base}api/v${this.version}/${entityId}/ProductStockRules/List`;
    const body = {
      productIds: productIds,
      locationIds: locationIds,
    };
    console.log(productIds);
    const params = {
      page: page,
      pageSize: pageSize,
    };

    return this.httpClient.post<IPaginatedResponse<IStockMinimumStockRule>>(
      url,
      body,
      { params: this.helperService.sanitizeParams(params) }
    );
  }

  createProductStockRule(
    entityId: string,
    ruleType: string,
    productId: string,
    value: number,
    locationId?: string
  ) {
    const url = `${this.base}api/v${this.version}/${entityId}/ProductStockRules`;
    const body = {
      ruleType: ruleType,
      productId: productId,
      value: value,
      locationId: locationId,
    };

    return this.httpClient.post(url, body);
  }

  getStockBelowMinimum(
    entityId: string,
    page: number = 1,
    pageSize: number = 25,
    locationIds: string[] = []
  ) {
    let url = `${this.base}api/v${this.version}/${entityId}/ProductStockRules/below-minimum`;

    const params = [];
    if (page) {
      params.push(`page=${page}`);
    }
    if (pageSize) {
      params.push(`pageSize=${pageSize}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    const body = {
      locationIds: locationIds,
    };

    return this.httpClient.post<IPaginatedResponse<IStockBelowMinimumItem>>(
      url,
      body
    );
  }

  updateProductStockRule(entityId: string, id: string, value: number) {
    const url = `${this.base}api/v${this.version}/${entityId}/ProductStockRules/${id}`;
    const body = {
      value: value,
    };

    return this.httpClient.put(url, body);
  }

  deleteProductStockRule(entityId: string, id) {
    const url = `${this.base}api/v${this.version}/${entityId}/ProductStockRules/${id}`;
    return this.httpClient.delete(url);
  }
}
